import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { scaffolderTooltipsTranslationRef } from '../../translation/scaffolder-tooltips/scaffolder-tooltips';

// -----------------------------------------------------------------------------------
// Resuelve una clave de `scaffolder-tooltips` (p. ej. "iacMvp.hostname") al texto del
// idioma activo.
//
// Existe porque las claves llegan como string en tiempo de ejecución: unas desde los
// custom fields y otras desde `ui:options.tooltipKey` del template.yaml, que vive en
// otro repositorio y por tanto no puede tiparse aquí. `t()` espera claves literales
// conocidas, de ahí el cast.
//
// Si la clave no existe, el runtime de i18n devuelve la propia clave; en ese caso se
// devuelve `undefined` para que el campo se pinte sin icono en lugar de mostrar al
// usuario un identificador interno.
// -----------------------------------------------------------------------------------

export const useScaffolderTooltip = (key?: string): string | undefined => {
  const { t } = useTranslationRef(scaffolderTooltipsTranslationRef);

  if (!key) return undefined;

  const text = t(key as Parameters<typeof t>[0]) as unknown as string;
  return !text || text === key ? undefined : text;
};
